import { useEffect } from 'react'

import Apptentive from 'helpers/apptentive'

const useTrackTimeOnPage = (eventName: string, eventTimesInSeconds: number[], startTracking = true) => {
  useEffect(() => {
    const timeouts = new Set<number>()

    if (startTracking) {
      eventTimesInSeconds.forEach((time) => {
        const timeoutId =
          window.setTimeout(() => {
            Apptentive.sendEvent(`${eventName}_${time}sec`)

            timeouts.delete(timeoutId)
          }, time * 1000)

        timeouts.add(timeoutId)
      })
    }

    return () => {
      timeouts.forEach((timeoutId) => {
        clearTimeout(timeoutId)
      })
    }
  }, [startTracking]) // eslint-disable-line react-hooks/exhaustive-deps
}

export default useTrackTimeOnPage
